import { lazyLoad } from "../../../../utils/loadable.js";

export const MyBills = lazyLoad(
    () => import("./index.js"),
    (module) => module.MyBills,
);
